<template>
  <h1 tabindex="0" class="sr-only" :aria-label="structureTitle">
    {{ structureTitle }}
  </h1>
</template>

<script setup lang="ts">
const { title } = defineProps(['title']);
const { $t } = useNuxtApp();
const structureTitle = computed(() => {
  return title ? $t(title) : document?.title || 'Untitled';
});
</script>

<style lang="scss" scoped>
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
